import { ClientOrgnizationDO } from './../../../BaseFramework/shared/models/client.model';
import { NewBusinessAppSettings } from './../../Newbusiness/newbusiness-configs/newbusiness-app-settings.config';
import { PersonEmploymentDO } from './../../../BaseFramework/shared/models/personEmployment.model';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  GuidGenerator,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ClientPersonDO, ClientAddressDO, ClientContactDO, ClientEmailDO } from 'app/BaseFramework/shared/models'
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

@Component({
  selector: 'app-capture-client-details',
  templateUrl: './capture-client-details.component.html',
  styleUrls: ['./capture-client-details.component.scss']
})
export class CaptureClientDetailsComponent implements OnInit {
  _currentComponentName = 'CaptureClientDetailsComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private commonUtilty: CommonUtilty,
    private guidGenerator: GuidGenerator,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    public newBusinessAppSettings: NewBusinessAppSettings) { }

  //Declaraions which might need developer input
  captureClientDetailsForm: FormGroup
  CAPTURECLIENTDETAILSFORMNAME = "captureClientDetailsForm"
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd', 'genderCd', 'titleCd', 'maritalStatusCd', 'relationCd', 'occupationCd', 'educationCd', 'citizenshipCd', 'sourceOfIncomeCd', 'yearlyIncomeRangeCd', 'clientTypeCd']
  selectorOfThisComponent = 'app-capture-client-address-details'
  parentEvent$
  titleCd
  item
  genderCd

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE 
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Output() changedField = new EventEmitter<any>();
  @Input() type: string;
  @Input() clientRole: string;
  @Input() modalFlag: any;

  checked=false;
  check=false;
  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };
  addressList: Array<any> = [];
  identityList: Array<any> = [];
  emailList: Array<any> = [];
  phoneList: Array<any> = [];
  isUpdatedAddress: boolean = false;
  isUpdatedPhone: boolean = false;
  isUpdatedMail: boolean = false;
  isUpdatedIdentity: boolean = false;

  allowedRoleTypes = {
    NOMINEE: 'Nominee',
    CLAIMANT: 'Claimant',
    OWNER: 'Policy Holder',
    PAYER: 'Payer',
    INSURED: 'Insured',
    VEHICLE: 'Vehicle',
    MEMBERS: 'Members',
    PRIMARYINSURED: 'Primary Insured',
    AGENT: 'Agent'
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  EmitChangedField(data){
    this.changedField.emit(data);
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = this.validateOutput(this.captureClientDetailsForm)
      if (isOutputValid)
        this.EmitComponentOutput(this.captureClientDetailsForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }

    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())

    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    //this._inputDataForEdit = this.dummyClientDO

    this.initializeClientCaptureForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
    if (this._inputDataForEdit)
      this.clientTransactionFormServerToUI(this._inputDataForEdit)

    this.onChanges();
  }



  /**
   * Form Trasactions
   */
  disableClientTypeCd
  initializeClientCaptureForm(data?) {

    let payload = data || {}

    console.log("ngOnint payload", payload);
    this.captureClientDetailsForm = this.fb.group({
      title: this.validationUtilService.setValidationsForFormControl('title', this.CAPTURECLIENTDETAILSFORMNAME, payload['title']),
      clientid: this.validationUtilService.setValidationsForFormControl('clientid', this.CAPTURECLIENTDETAILSFORMNAME, payload['id']),
      clientGuid: this.validationUtilService.setValidationsForFormControl('clientGuid', this.CAPTURECLIENTDETAILSFORMNAME, payload['guid']),
      clientNum: this.validationUtilService.setValidationsForFormControl('clientNum', this.CAPTURECLIENTDETAILSFORMNAME, payload['clientNum']),
      statusCd: this.validationUtilService.setValidationsForFormControl('statusCd', this.CAPTURECLIENTDETAILSFORMNAME, payload['statusCd']),
      id: this.validationUtilService.setValidationsForFormControl('clientid', this.CAPTURECLIENTDETAILSFORMNAME, payload['id']),
      clientTypeCd: this.validationUtilService.setValidationsForFormControl('clientTypeCd', this.CAPTURECLIENTDETAILSFORMNAME, payload['clientTypeCd']),
      gender: this.validationUtilService.setValidationsForFormControl('gender', this.CAPTURECLIENTDETAILSFORMNAME, payload['gender']),
      firstName: this.validationUtilService.setValidationsForFormControl('firstName', this.CAPTURECLIENTDETAILSFORMNAME, payload['firstName']),
      middleName: this.validationUtilService.setValidationsForFormControl('middleName', this.CAPTURECLIENTDETAILSFORMNAME, payload['middleName']),
      lastName: this.validationUtilService.setValidationsForFormControl('lastName', this.CAPTURECLIENTDETAILSFORMNAME, payload['lastName']),
      dateOfBirth: this.validationUtilService.setValidationsForFormControl('dateOfBirth', this.CAPTURECLIENTDETAILSFORMNAME, payload['dateOfBirth']),
      educationTypeCd: this.validationUtilService.setValidationsForFormControl('educationTypeCd', this.CAPTURECLIENTDETAILSFORMNAME, payload['educationTypeCd']),
      emailType: this.validationUtilService.setValidationsForFormControl('emailType', this.CAPTURECLIENTDETAILSFORMNAME, payload['emailType']),
      personId: this.validationUtilService.setValidationsForFormControl('personId', this.CAPTURECLIENTDETAILSFORMNAME, payload['personId']),
      personGuid: this.validationUtilService.setValidationsForFormControl('personGuid', this.CAPTURECLIENTDETAILSFORMNAME, payload['personGuid']),
      sourceOfIncome: this.validationUtilService.setValidationsForFormControl('sourceOfIncome', this.CAPTURECLIENTDETAILSFORMNAME, payload['sourceOfIncome']),
      incomeRange: this.validationUtilService.setValidationsForFormControl('incomeRange', this.CAPTURECLIENTDETAILSFORMNAME, payload['incomeRange']),

      SOE: this.validationUtilService.setValidationsForFormControl('SOE', this.CAPTURECLIENTDETAILSFORMNAME, payload['SOE']),
      // occupationCd: this.validationUtilService.setValidationsForFormControl('occupationCd', this.CAPTURECLIENTDETAILSFORMNAME, payload['occupationCd']),
      nationality: this.validationUtilService.setValidationsForFormControl('nationality', this.CAPTURECLIENTDETAILSFORMNAME, payload['nationality']),
      maritalStatus: this.validationUtilService.setValidationsForFormControl('maritalStatus', this.CAPTURECLIENTDETAILSFORMNAME, payload['maritalStatus']),
      relationCd: this.validationUtilService.setValidationsForFormControl('relationCd', this.CAPTURECLIENTDETAILSFORMNAME, payload['relationCd']),
      externalClientNum: this.validationUtilService.setValidationsForFormControl('externalClientNum', this.CAPTURECLIENTDETAILSFORMNAME, payload['externalClientNum']),
      organisationId: this.validationUtilService.setValidationsForFormControl('organisationId', this.CAPTURECLIENTDETAILSFORMNAME, payload['organisationId']),
      organisationGuid: this.validationUtilService.setValidationsForFormControl('organisationGuid', this.CAPTURECLIENTDETAILSFORMNAME, payload['organisationGuid']),
      companyName: this.validationUtilService.setValidationsForFormControl('companyName', this.CAPTURECLIENTDETAILSFORMNAME, payload['companyName']),
      contactPersonName: this.validationUtilService.setValidationsForFormControl('contactPersonName', this.CAPTURECLIENTDETAILSFORMNAME, payload['contactPersonName']),
      //relationshipCd: this.validationUtilService.setValidationsForFormControl('relationshipCd', this.CAPTURECLIENTDETAILSFORMNAME, payload['relationCd']),
      //UID:  this.validationUtilService.setValidationsForFormControl('UID', this.CAPTURECLIENTDETAILSFORMNAME, payload['UID']),
      noOfChildren: this.validationUtilService.setValidationsForFormControl('noOfChildren', this.CAPTURECLIENTDETAILSFORMNAME, payload['noOfChildren']),
      gstNumber: this.validationUtilService.setValidationsForFormControl('gstNumber', this.CAPTURECLIENTDETAILSFORMNAME, payload['gstNumber']),
      haveCKYCNumber: this.validationUtilService.setValidationsForFormControl('haveCKYCNumber', this.CAPTURECLIENTDETAILSFORMNAME, payload['haveCKYCNumber']),
      CKYCNumber: this.validationUtilService.setValidationsForFormControl('CKYCNumber', this.CAPTURECLIENTDETAILSFORMNAME, payload['CKYCNumber']),
      //existingCustomer: this.validationUtilService.setValidationsForFormControl('existingCustomer', this.CAPTURECLIENTDETAILSFORMNAME, payload['existingCustomer']),
      //employeeCode: this.validationUtilService.setValidationsForFormControl('employeeCode', this.CAPTURECLIENTDETAILSFORMNAME, payload['employeeCode']),
      //premiumPaymentZone: this.validationUtilService.setValidationsForFormControl('premiumPaymentZone', this.CAPTURECLIENTDETAILSFORMNAME, payload['premiumPaymentZone']),
      //proposerRelation: this.validationUtilService.setValidationsForFormControl('proposerRelation', this.CAPTURECLIENTDETAILSFORMNAME, payload['proposerRelation']),
      //age: this.validationUtilService.setValidationsForFormControl('age', this.CAPTURECLIENTDETAILSFORMNAME, payload['age']),
      height: this.validationUtilService.setValidationsForFormControl('height', this.CAPTURECLIENTDETAILSFORMNAME, payload['height']),
      weight: this.validationUtilService.setValidationsForFormControl('weight', this.CAPTURECLIENTDETAILSFORMNAME, payload['weight']),
      //sumInsured: this.validationUtilService.setValidationsForFormControl('sumInsured', this.CAPTURECLIENTDETAILSFORMNAME, payload['sumInsured']),
      nominee: this.validationUtilService.setValidationsForFormControl('nominee', this.CAPTURECLIENTDETAILSFORMNAME, payload['nominee']),
      nomineeRelation: this.validationUtilService.setValidationsForFormControl('nomineeRelation', this.CAPTURECLIENTDETAILSFORMNAME, payload['nomineeRelation']),
      //familyMonthlyIncome: this.validationUtilService.setValidationsForFormControl('familyMonthlyIncome', this.CAPTURECLIENTDETAILSFORMNAME, payload['familyMonthlyIncome']),
      //sumInsuredOptions: this.validationUtilService.setValidationsForFormControl('sumInsuredOptions', this.CAPTURECLIENTDETAILSFORMNAME, payload['sumInsuredOptions']),
      //familyFloaterSumInsured: this.validationUtilService.setValidationsForFormControl('familyFloaterSumInsured', this.CAPTURECLIENTDETAILSFORMNAME, payload['familyFloaterSumInsured']),
      copyOfEmail: this.validationUtilService.setValidationsForFormControl('copyOfEmail', this.CAPTURECLIENTDETAILSFORMNAME, payload['copyOfEmail']),
      contactByMobile: this.validationUtilService.setValidationsForFormControl('contactByMobile', this.CAPTURECLIENTDETAILSFORMNAME, payload['contactByMobile']),
      
      annualIncome: this.validationUtilService.setValidationsForFormControl('annualIncome', this.CAPTURECLIENTDETAILSFORMNAME, payload['annualIncome']),
      bmi: this.validationUtilService.setValidationsForFormControl('bmi', this.CAPTURECLIENTDETAILSFORMNAME, payload['bmi']),
      occupationCd: this.validationUtilService.setValidationsForFormControl('occupationCd', this.CAPTURECLIENTDETAILSFORMNAME, payload['occupationCd']),
    });

    console.log("capture client details form", this.captureClientDetailsForm);
    this.validationHandler()
    this.selectDefaultClientTypeAndDisable(this.captureClientDetailsForm.get('clientTypeCd').value);
  }

  private selectDefaultClientTypeAndDisable(type?) {
    let defaultClientType = type || 'PERSON'
    let clientTypeControl = this.captureClientDetailsForm.get('clientTypeCd')
    if (clientTypeControl && !clientTypeControl.value)
      clientTypeControl.setValue(defaultClientType);
    this.disableClientTypeCd = true;
  }

  validationHandler(handlerData?) {
    let personDOFields = ["title", "firstName", "middleName", "lastName", "gender", "dateOfBirth",
      "nationality", "countryOfBirthCd", "maritalStatusCd", "relationCd", "occupationCd", "educationTypeCd", "SOE"]
    let organisationDOFields = ["companyName", "contactPersonName"]

    this.captureClientDetailsForm.get('clientTypeCd').valueChanges.subscribe(
      (type: string) => {
        if (type == 'PERSON') {
          personDOFields.forEach(ctrlName => {
            if (this.captureClientDetailsForm.get(ctrlName)) {
              this.captureClientDetailsForm.get(ctrlName).setValidators([...this.validationUtilService.getListOfValidators(null, ctrlName, this.CAPTURECLIENTDETAILSFORMNAME)]);
              this.captureClientDetailsForm.get(ctrlName).updateValueAndValidity();
            }
          })
          organisationDOFields.forEach(ctrlName => {
            if (this.captureClientDetailsForm.get(ctrlName)) {
              this.captureClientDetailsForm.get(ctrlName).clearValidators();
              this.captureClientDetailsForm.get(ctrlName).updateValueAndValidity();
            }
          })
        }
        else if (type == 'ORGANIZATION') {
          organisationDOFields.forEach(ctrlName => {
            if (this.captureClientDetailsForm.get(ctrlName)) {
              this.captureClientDetailsForm.get(ctrlName).setValidators([...this.validationUtilService.getListOfValidators(null, ctrlName, this.CAPTURECLIENTDETAILSFORMNAME)]);
              this.captureClientDetailsForm.get(ctrlName).updateValueAndValidity();
            }
          })
          personDOFields.forEach(ctrlName => {
            if (this.captureClientDetailsForm.get(ctrlName)) {
              this.captureClientDetailsForm.get(ctrlName).clearValidators();
              this.captureClientDetailsForm.get(ctrlName).updateValueAndValidity();
            }
          })
        }
      });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.CAPTURECLIENTDETAILSFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }


  fetchAddressList(addressList) {
    this.isUpdatedAddress = true;
    this.addressList = addressList.componentData;
  }
  fetchIdentityList(identityList) {
    this.isUpdatedIdentity = true;
    this.identityList = identityList.componentData;
  }
  fetchEmailList(emailList) {
    this, this.isUpdatedMail = true;
    this.emailList = emailList.componentData;
  }
  fetchphoneList(phoneList) {
    this.isUpdatedPhone = true;
    this.phoneList = phoneList.componentData;
  }
  transformClient() {
    console.log("Transform client", this.captureClientDetailsForm);
    let isOutputValid = this.validateOutput(this.captureClientDetailsForm)
    if (!isOutputValid.isInvalid)
      var payload = this.transFormUIToClientDO(this.captureClientDetailsForm);
    else {
      this.notification.error('Not Valid', 'Form is not valid');
    }



  }
  transFormUIToClientDO(UIDO: FormGroup) {
    console.log("before transform", this._inputDataForEdit);
    //  let transformedPayload = this.getEmptyAgentRegistrationPayload()
    this._inputDataForEdit = this.setClientDO(UIDO)
    console.log("after transform", this._inputDataForEdit);
    let output = { role: this.allowedRoleTypes[this.clientRole], clientDO: this._inputDataForEdit }
    let emailflag = false, addressFlag = false, contactFlag = false;
    if (this._inputDataForEdit.clientEmailList && this._inputDataForEdit.clientEmailList.length > 0) {
      let preferredEmail = this._inputDataForEdit.clientEmailList.find(item => true)
      if (!preferredEmail.prefferedFl) {
        emailflag = true;
        this.notification.error('Primary email-id not selected', 'Please select one primary email');
      } else {
        emailflag = false;
      }
    }
    if (this._inputDataForEdit.clientAddressList && this._inputDataForEdit.clientAddressList.length > 0) {
      let preferredAddress = this._inputDataForEdit.clientAddressList.find(item => true)
      if (!preferredAddress.prefferedFl) {
        addressFlag = true;
        this.notification.error('Primary address not selected', 'Please select one primary address');
      } else {
        addressFlag = false;
      }
    }
    if (this._inputDataForEdit.clientContactDetailsList && this._inputDataForEdit.clientContactDetailsList.length > 0) {
      let preferredContact = this._inputDataForEdit.clientContactDetailsList.find(item => true)
      if (!preferredContact.prefferedFl) {
        contactFlag = true;
        this.notification.error('Primary contact number not selected', 'Please select one primary contact number');
      } else {
        contactFlag = false;
      }
    }
    //clientEmailList clientAddressList  clientContactDetailsList
    if (!emailflag && !addressFlag && !contactFlag) {

      if (output.role != 'Policy Holder') {
        let insuredName = output.clientDO.personDO.firstName + " " + output.clientDO.personDO.lastName
        this.commonUtilty.addLookupDataToCache(output.clientDO.guid, insuredName, "insuredCd");
      }
      this.interactService.sendClientDOtoClientList(output)
      this.interactService.closeAllModel(this.modalFlag);
    }
  }

  setClientDO(UIDO: FormGroup) {
    console.log("UIDO", UIDO);
    let returnData = this._inputDataForEdit;
    let clientid = UIDO.get('clientid').value
    let guid = UIDO.get('clientGuid').value;
    let personId = UIDO.get('personId').value
    let personGuid = UIDO.get('personGuid').value

    if (guid === null)
      guid = this.guidGenerator.setGuid()

    //TODO Organization Change
    let clientType = UIDO.get('clientTypeCd').value
    let status = UIDO.get('statusCd').value
    if (clientType === 'PERSON') {
      returnData = new ClientPersonDO();
      // returnData.deDupStatusCd = "BYPASS"
      returnData.organisationDO = null
      returnData.personDO.id = personId
      returnData.personDO.guid = personGuid
      returnData.personDO.firstName = UIDO.get('firstName').value;
      returnData.personDO.middleName = UIDO.get('middleName').value;
      returnData.personDO.lastName = UIDO.get('lastName').value;
      returnData.personDO.genderCd = UIDO.get('gender').value;
      returnData.personDO.dateOfBirth = UIDO.get('dateOfBirth').value;
      returnData.personDO.personEducationList = [{ educationTypeCd: UIDO.get('educationTypeCd').value }]
      returnData.personDO.personEducation = [{ educationTypeCd: UIDO.get('educationTypeCd').value }]
      var personOccupation = new PersonEmploymentDO();
      personOccupation.occupationCd = UIDO.get('occupationCd').value;
      personOccupation.yearlyIncomeRangeCd = UIDO.get('incomeRange').value;
      returnData.personDO.personEmploymentList.push(personOccupation);
      returnData.personDO.sourceOfIncomeCd = UIDO.get('sourceOfIncome').value;
      returnData.personDO.maritalStatusCd = UIDO.get('maritalStatus').value;
      returnData.personDO.citizenshipCd = UIDO.get('nationality').value;
      returnData.personDO.height = UIDO.get('height').value;
      returnData.personDO.weight = UIDO.get('weight').value;
      // returnData.personDO.dateOfBirth = this.commonUtilty.UIDOtoServerDODate(UIDO.get('dateOfBirth').value)
      returnData.personDO.titleCd = UIDO.get('title').value;
      returnData.personDO.personIdentityList = this.setIdentityForTheClient();
    }
    else if (clientType == 'ORGANIZATION') {
      returnData = new ClientOrgnizationDO();
      returnData.personDO = null
      returnData.organisationDO = {}
      returnData.organisationDO.id = UIDO.get('organisationId').value;
      returnData.organisationDO.guid = UIDO.get('organisationGuid').value;
      returnData.organisationDO.companyName = UIDO.get('companyName').value;
      returnData.organisationDO.contactPersonName = UIDO.get('contactPersonName').value;
    }

    returnData.guid = guid
    returnData.id = clientid
    returnData.statusCd = status
    returnData.duplicateFl = false
    returnData.blackListedFl = false



    returnData.clientTypeCd = clientType
    returnData.clientNum = UIDO.get('clientNum').value
    returnData.statusCd = UIDO.get('statusCd').value
    returnData.emailType = UIDO.get('emailType').value
    returnData.personId = UIDO.get('personId').value
    returnData.SOE = UIDO.get('SOE').value
    returnData.occupationCd = UIDO.get('occupationCd').value
    returnData.nationality = UIDO.get('nationality').value
    returnData.maritalStatus = UIDO.get('maritalStatus').value
    returnData.relationCd = UIDO.get('relationCd').value
    returnData.externalClientNum = UIDO.get('externalClientNum').value


    returnData.clientAddressList = this.setAddressForTheClient()
    returnData.clientContactDetailsList = this.setMobileForTheClient()
    returnData.clientEmailList = this.setEmailForTheClient()
    console.log(JSON.stringify(returnData))
    return returnData
  }

  setAddressForTheClient() {
    if (this.isUpdatedAddress == false) {
      return this.inputClientCaptureAddressDetailsList;
    }
    return this.addressList;
  }

  setIdentityForTheClient() {
    if (this.isUpdatedIdentity == false) {
      return this.inputClientCaptureIdentityDetailsList;
    }
    return this.identityList;
  }

  setMobileForTheClient() {
    if (this.isUpdatedPhone == false) {
      return this.inputClientCapturePhoneDetailsList
    }
    return this.phoneList;
  }

  setEmailForTheClient() {
    if (this.isUpdatedMail == false) {
      return this.inputClientCaptureEmailDetailsList
    }
    return this.emailList
  }

  currentLanguage = 'EN'

  public genericSearchLabel = {
    clientType: {
      EN: "Client Type",
      TH: "Client Type"
    },
    title: {
      EN: "Title",
      TH: "Title"
    },
    firstName: {
      EN: "First Name",
      TH: "First Name"
    },
    middleName: {
      EN: "Middle Name",
      TH: "Middle Name"
    },
    lastName: {
      EN: "Last Name",
      TH: "Last Name"
    },
    gender: {
      EN: "Gender",
      TH: "เพศ"
    },
    dateOfBirth: {
      EN: "Date Of Birth",
      TH: "วนั/เดือน/ปีเกิด"
    },
    nationality: {
      EN: "Nationality",
      TH: "สัญชาต"
    },
    maritalStatus: {
      EN: "Marital Status",
      TH: "สถานภาพการสมรส"
    },
    occupation: {
      EN: "Occupation",
      TH: "อาชีพ"
    },
    highestQualification: {
      EN: "Highest Qualification",
      TH: "Highest Qualification"
    },
    sourceOfIncome: {
      EN: "Source Of Income",
      TH: "Source Of Income"
    },
    incomeRange: {
      EN: "Income Range",
      TH: "รายได"
    },
    relationshipWithPolicyHolder: {
      EN: "Relationship with Proposal",
      TH: "Relationship with Proposal"
    },
    companyName: {
      EN: "Company Name",
      TH: "Company Name"
    },
    contactPerson: {
      EN: "Contact Person",
      TH: "Contact Person"
    },
    /*UID: {
      EN: "UID/Unique ID",
      TH: "UID/Unique ID"
    },*/
    noOfChildren: {
      EN:"No. of Children",
      TH:"No. of Children"
    },
    gstNumber: {
      EN: "GST Number",
      TH: "GST Number"
    },
    haveCKYCNumber: {
      EN: "Do you have a CKYC number (Yes/No)",
      TH: "Do you have a CKYC number (Yes/No)"
    },
    CKYCNumber: {
      EN: "CKYC number",
      TH: "CKYC number"
    },
    /*existingCustomer: {
      EN: "Are you an existing Customer",
      TH: "Are you an existing Customer"
    },
    employeeCode: {
      EN: "Employee Code",
      TH: "Employee Code"
    },
    premiumPaymentZone: {
      EN: "Premium Payment Zone (ZoneA/ZoneB)",
      TH: "Premium Payment Zone (ZoneA/ZoneB)"
    },
    proposerRelation: {
      EN: "Relationship with Proposer",
      TH: "Relationship with Proposer"
    },
    age: {
      EN: "Age",
      TH: "Age"
    },*/
    height: {
      EN: "Height (in cm)",
      TH: "Height (in cm)"
    },
    weight: {
      EN: "Weight (in kg)",
      TH: "Weight (in kg)"
    },
    bmi: {
      EN: "BMI",
      TH: "BMI"
    },
    annualIncome: {
      EN: "Annual Income",
      TH: "Annual Income"
    },
    /*sumInsured: {
      EN: "Sum Insured (in INR)",
      TH: "Sum Insured (in INR)"
    },*/
    nominee: {
      EN: "Nominee",
      TH: "Nominee"
    },
    nomineeRelation: {
      EN: "Nominee Relationship with Insured",
      TH: "Nominee Relationship with Insured"
    },
    /*familyMonthlyIncome: {
      EN: "Family Monthly Income",
      TH: "Family Monthly Income"
    },
    sumInsuredOptions: {
      EN: "Individual Sum Insured Options",
      TH: "Individual Sum Insured Options"
    },
    familyFloaterSumInsured: {
      EN: "Family Floater Sum Insured in INR",
      TH: "Family Floater Sum Insured in INR"
    },*/
  }

  public genericSearchLabel1 = {
    EN: {
      clientType: "ClientTypeEN"
    },
    TBH: {
      clientType: "ClientTypeTH"
    }
  }


  getEmptyAgentRegistrationPayload() {
    var emptyPayloadold = {
      "clientDO": null,
    }

    var emptyPayload = {
      "clientDO": {
        "parentObject": null,
        "versionId": null,
        "id": null,
        "guid": "82b9cf3d-6985-484a-8da8-dddc9a6b3fe1",
        "clientTypeCd": "PERSON",
        "statusCd": "ACTIVE",
        "duplicateFl": false,
        "blackListedFl": false,
        "organisationDO": null,
        "personDO": {
          "parentObject": null,
          "versionId": null,
          "guid": null,
          "createdDt": null,
          "updatedDt": null,
          "createdUser": null,
          "updatedUser": null,
          "id": null,
          "titleCd": null,
          "firstName": "Ninad",
          "middleName": null,
          "lastName": "Kulkarni",
          "firstName1": null,
          "middleName1": null,
          "lastName1": null,
          "genderCd": null,
          "dateOfBirth": null,
          "age": null,
          "maritalStatusCd": null,
          "mothersMaidenName": null,
          "fathersName": null,
          "givenName": null,
          "legalName": null,
          "otherName": null,
          "countryOfBirthCd": null,
          "citizenshipCd": null,
          "politicalFlag": null,
          "convictedFlag": null,
          "personEmploymentList": [],
          "personIdentityList": [],
          "objectName": "PersonDO",
          "clientStatusCd": null
        },
        "clientAddressList": [
          {
            "parentObject": null,
            "versionId": null,
            "guid": null,
            "id": null,
            "clientAddressID": null,
            "typeCd": "BUSINESS",
            "addressLine1": "abc",
            "addressLine2": null,
            "addressLine3": null,
            "addressLine4": null,
            "cityCd": "JAKARTA_PUSAT",
            "talukaCd": null,
            "villageCd": null,
            "stateCd": "DKI_JAKARTA",
            "countryCd": "INA",
            "postCode": "10110",
            "prefferedFl": 1,
            "objectName": "ClientAddressDO",
            "offlineGuid": null,
            "agentDeviceSeq": null,
            "addressTypeCd": null,
            "addressSubTypeCd": null,
            "postCd": null
          }
        ],
        "clientContactDetailsList": [
          {
            "parentObject": null,
            "versionId": null,
            "guid": null,
            "createdDt": null,
            "updatedDt": null,
            "createdUser": null,
            "updatedUser": null,
            "id": null,
            "typeCd": "MOBILE",
            "subTypeCd": null,
            "contactNum": "9028048475",
            "extensionNum": null,
            "prefferedFl": 1,
            "objectName": "ClientPhoneDO",
            "isd": null,
            "std": null
          }
        ],
        "clientEmailList": [
          {
            "parentObject": null,
            "versionId": null,
            "guid": null,
            "createdDt": null,
            "updatedDt": null,
            "createdUser": null,
            "updatedUser": null,
            "caseManager": null,
            "id": null,
            "typeCd": "BUSINESS",
            "emailId": "ninad@metamorphtech.com",
            "prefferedFl": 1,
            "objectName": "ClientEmailDO"
          }
        ],
        "clientAdditionalFieldDOs": [],
        "objectName": "ClientDO",
        "offlineGuid": null,
        "agentDeviceSeq": null,
        "systemCreatedDt": null,
        "systemUpdatedDt": null,
        "onlineCreatedDt": null,
        "onlineUpdatedDt": null,
        "systemCreatedUser": null,
        "systemUpdatedUser": null,
        "customerId": null
      }
    }

    return emptyPayload;
  }


  dummyClientDO =
    {
      "parentObject": null,
      "versionId": 2,
      "guid": "BCE686E8-BC34-47CC-8F2E-CCFF46F68A9C",
      "createdDt": 1559546247523,
      "updatedDt": 1560322637205,
      "createdUser": "AdminScript",
      "updatedUser": "INT1",
      "caseManager": null,
      "fieldKey": null,
      "fieldValue": null,
      "id": 2,
      "externalClientNum": null,
      "clientTypeCd": "PERSON",
      "clientNum": "C00071",
      "deDupStatusCd": null,
      "statusCd": null,
      "duplicateFl": null,
      "blackListedFl": null,
      "blackListedReasonCd": null,
      "duplicateClientNum": null,
      "fromEffectiveDT": null,
      "lastEffectiveDt": null,
      "organisationDO": null,
      "personDO": {
        "parentObject": null,
        "versionId": 1,
        "guid": "f8ed86bd-ff07-45f7-b104-e85f5e28e695",
        "createdDt": 1559546247546,
        "updatedDt": 1560322637206,
        "createdUser": "AdminScript",
        "updatedUser": "INT1",
        "caseManager": null,
        "id": 2,
        "titleCd": 'MR',
        "firstName": "Jill",
        "middleName": null,
        "lastName": "Smith",
        "firstName1": null,
        "middleName1": null,
        "lastName1": null,
        "genderCd": "FEMALE",
        "dateOfBirth": 34214400000,
        "age": null,
        "maritalStatusCd": null,
        "mothersMaidenName": null,
        "fathersName": null,
        "givenName": null,
        "legalName": null,
        "otherName": null,
        "countryOfBirthCd": null,
        "citizenshipCd": null,
        "politicalFlag": null,
        "convictedFlag": null,
        "sourceOfIncomeCd": null,
        "fromEffectiveDT": null,
        "lastEffectiveDt": null,
        "personEmploymentList": [],
        "personIdentityList": [],
        "objectName": "PersonDO",
        "name": "Jill Smith"
      },
      "clientAddressList": [
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "80638f36-78d1-488e-bdcb-b1b22e84a2ec",
          "createdDt": 1559546247596,
          "updatedDt": 1560322637207,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 2,
          "clientAddressID": null,
          "typeCd": "RESIDENCE",
          "subTypeCd": null,
          "addressLine1": "House 101",
          "addressLine2": "Sussex St",
          "addressLine3": null,
          "addressLine4": null,
          "cityCd": "PUNE",
          "talukaCd": null,
          "villageCd": null,
          "stateCd": "MAHARASHTRA",
          "countryCd": "INDIA",
          "postCode": 412307,
          "prefferedFl": true,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientAddressDO"
        },
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "5f70a86e-3cef-44a0-9ca1-91ed9c209c9b",
          "createdDt": 1559546247653,
          "updatedDt": 1560322637208,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 13,
          "clientAddressID": null,
          "typeCd": "MAILING",
          "subTypeCd": null,
          "addressLine1": "House 701",
          "addressLine2": "Sussex St",
          "addressLine3": null,
          "addressLine4": null,
          "cityCd": "AHMEDNAGAR",
          "talukaCd": null,
          "villageCd": null,
          "stateCd": "MAHARASHTRA",
          "countryCd": "INDIA",
          "postCode": 413701,
          "prefferedFl": false,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientAddressDO"
        }
      ],
      "clientContactDetailsList": [
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "17258d35-3947-4faf-bfbe-5526ad16136d",
          "createdDt": 1559546247806,
          "updatedDt": 1560322637207,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 2,
          "typeCd": "BUSINESS",
          "subTypeCd": null,
          "contactNum": "'112233000071",
          "extensionNum": null,
          "prefferedFl": true,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "isd": null,
          "std": null,
          "objectName": "ClientPhoneDO"
        },
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "8c8fb47e-4dc0-4e9a-bbea-8bc50b94a2fe",
          "createdDt": 1559546247856,
          "updatedDt": 1560322637207,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 13,
          "typeCd": "HOME",
          "subTypeCd": null,
          "contactNum": "'992233000071",
          "extensionNum": null,
          "prefferedFl": false,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "isd": null,
          "std": null,
          "objectName": "ClientPhoneDO"
        }
      ],
      "clientEmailList": [
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "6649176e-6348-42e3-9901-943d9ec00489",
          "createdDt": 1559546247710,
          "updatedDt": 1560322637206,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 2,
          "typeCd": "BUSINESS",
          "emailId": "Jill_Smith@testmail.com",
          "prefferedFl": true,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientEmailDO"
        },
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "14a6cdbe-fce1-4380-b96e-e06ecd76deec",
          "createdDt": 1559546247756,
          "updatedDt": 1560322637206,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 13,
          "typeCd": "PERSONAL",
          "emailId": "Jill_Smith_1@testmail.com",
          "prefferedFl": false,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientEmailDO"
        }
      ],
      "clientAdditionalFieldDOs": [],
      "clientRelationshipDOs": [],
      "preferredEmail": "Jill_Smith@testmail.com",
      "preferredMobileNum": null,
      "objectName": "ClientDO",
      "name": "Jill Smith"
    }
  _inputClientCapturePersonDetailsComponent = {}
  inputClientCaptureAddressDetailsList: any = []
  inputClientCaptureIdentityDetailsList: any = []
  inputClientCaptureEmailDetailsList: any = []
  inputClientCapturePhoneDetailsList: any = []

  clientTransactionFormServerToUI(serverDO?) {
    let payload = serverDO || {}


    this._inputClientCapturePersonDetailsComponent = this.ClientPersonDetailsServerDOToComponentMapper(payload);
    this.initializeClientCaptureForm(this._inputClientCapturePersonDetailsComponent)

    if (payload.clientAddressList) {
      this.inputClientCaptureAddressDetailsList = payload.clientAddressList;
    }
    if (payload.clientContactDetailsList) {
      this.inputClientCapturePhoneDetailsList = payload.clientContactDetailsList;
    }
    if (payload.clientEmailList) {
      this.inputClientCaptureEmailDetailsList = payload.clientEmailList;
    }

    if (payload['personDO'].personIdentityList) {
      this.inputClientCaptureIdentityDetailsList = payload['personDO'].personIdentityList;
    }
  }

  //TODO Organization Change
  ClientPersonDetailsServerDOToComponentMapper(payload) {
    var output = {}

    console.log("Payload ", JSON.stringify(payload));
    output['clientTypeCd'] = payload.clientTypeCd
    //Education Extract
    let personEducationList
    let personEducationDO
    let occupationList
    let occupationDO
    if (payload && payload.personDO) {
      output['title'] = payload.personDO.titleCd
      output['firstName'] = payload.personDO.firstName
      output['middleName'] = payload.personDO.middleName
      output['lastName'] = payload.personDO.lastName
      output['title'] = payload.personDO.titleCd
      output['dateOfBirth'] = this.commonUtilty.serverDOtoUIDODate(payload.personDO.dateOfBirth)
      output['gender'] = payload.personDO.genderCd;
      output['sourceOfIncome'] = payload.personDO['sourceOfIncomeCd']
      output['emailType'] = payload.personDO.emailType
      output['personId'] = payload.personDO.personId
      output['personGuid'] = payload.personDO.personGuid
      output['SOE'] = payload.personDO.SOE
      output['height'] = payload.personDO.height
      output['weight'] = payload.personDO.weight
      output['id'] = payload.id
      output['nationality'] = payload.personDO.citizenshipCd
      personEducationList = payload.personDO.personEducationList || payload.personDO.personEducation
      output['annualIncome'] = payload.annualIncome
      output['occupationCd'] = payload.occupationCd
      output['bmi'] = payload.bmi
      occupationList = payload.personDO.personEmploymentList;
    }

    if (payload && payload.organisationDO) {
      output['organisationId'] = payload.organisationDO.id
      output['organisationGuid'] = payload.organisationDO.guid
      output['companyName'] = payload.organisationDO.companyName
      output['contactPersonName'] = payload.organisationDO.contactPersonName
    }

    if (this.commonUtilty.isArrayIterable(personEducationList))
      personEducationDO = personEducationList.find(educationDO => true)
    if (personEducationDO)
      output['educationTypeCd'] = personEducationDO.educationTypeCd

    if (this.commonUtilty.isArrayIterable(occupationList))
      occupationDO = occupationList.find(occupationDO => true)
    if (occupationDO)
      output['incomeRange'] = occupationDO.yearlyIncomeRangeCd
    //Education Extract Ends
    output['clientid'] = payload['id']
    output['guid'] = payload['guid']
    output['clientNum'] = payload['clientNum']
    output['statusCd'] = payload['statusCd']
    //TODO verify below field in ClinetDO hierarchy
    output['occupationCd'] = payload['occupationCd']
    output['nationality'] = payload['citizenshipCd']
    output['maritalStatus'] = payload['maritalStatus']
    output['relationCd'] = payload['relationCd']
    output['externalClientNum'] = payload['externalClientNum']



    return output
  }

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (!Form.valid) {
      for (const i in Form.controls) {

        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.captureClientDetailsForm.get(controlName), this.CAPTURECLIENTDETAILSFORMNAME)
        if (Form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError;
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    return invalidFields;
  }

  onChanges(): void {
    this.captureClientDetailsForm.get('gender').valueChanges.subscribe(val => {
      if (val) {
        if (val === 'MALE')
          this.captureClientDetailsForm.get('title').setValue('MR')
        else if (val === 'FEMALE')
          this.captureClientDetailsForm.get('title').setValue('MRS')
      }
    })
  }
  fieldOnChangeHandler(fieldKey){
    this.changedField.emit(fieldKey)
  }

  FormFieldNameMap = {
    firstName: "First Name",
    lastName: "Last Name",
  }

}

